/* Native disclosures with brief, interruptible motion; no animation loop. */
if (!customElements.get('objectiv-shop-faqs')) {
  customElements.define('objectiv-shop-faqs', class extends HTMLElement {
    connectedCallback() {
      if (this.lifetime) return;
      this.lifetime = new AbortController();
      this.active = new Map();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.lifetime.signal };
      this.addEventListener('click', event => this.toggle(event), options);
      this.motion.addEventListener('change', () => this.settle(), options);
      window.addEventListener('resize', () => this.settle(), options);
      this.expandButton = this.querySelector('[data-faq-expand-all]');
      if (this.expandButton) {
        this.expandButton.hidden = false;
        this.expandButton.addEventListener('click', () => {
          this.settle();
          const faqs = [...this.querySelectorAll('.obj-shop__faq')];
          const open = !faqs.every(details => details.open);
          faqs.forEach(details => { details.open = open; });
          this.updateExpandState();
        }, options);
        this.addEventListener('toggle', () => this.updateExpandState(), { ...options, capture: true });
        this.updateExpandState();
      }
    }

    disconnectedCallback() {
      this.settle();
      this.lifetime?.abort();
      this.lifetime = null;
    }

    settle() {
      for (const [details, state] of this.active || []) this.finish(details, state);
    }

    updateExpandState() {
      const allOpen = [...this.querySelectorAll('.obj-shop__faq')]
        .every(details => this.active.get(details)?.open ?? details.open);
      this.expandButton?.setAttribute('aria-expanded', String(allOpen));
      const label = this.expandButton?.querySelector('[data-faq-toggle-label]');
      if (label) label.textContent = allOpen ? 'Close all' : 'Expand all';
    }

    finish(details, state) {
      if (this.active.get(details) !== state) return;
      this.active.delete(details);
      details.open = state.open;
      state.height.cancel();
      state.answer.cancel();
      details.classList.remove('is-animating', 'is-closing');
      this.updateExpandState();
    }

    toggle(event) {
      const summary = event.target.closest('summary');
      const details = summary?.parentElement;
      if (event.defaultPrevented || !details?.matches('.obj-shop__faq') ||
          !this.contains(details) || this.motion.matches || !details.animate) return;
      const answer = details.querySelector('.obj-shop__faq-answer');
      if (!answer) return;
      event.preventDefault();

      const previous = this.active.get(details);
      const open = !(previous ? previous.open : details.open);
      const startHeight = details.getBoundingClientRect().height;
      const answerStyle = getComputedStyle(answer);
      const startOpacity = previous ? answerStyle.opacity : details.open ? '1' : '0';
      const startTransform = previous ? answerStyle.transform : details.open ? 'none' : 'translateY(4px)';
      previous?.height.cancel();
      previous?.answer.cancel();

      // Keep the native answer visible until a closing animation completes.
      details.open = true;
      details.classList.add('is-animating');
      details.classList.toggle('is-closing', !open);
      const style = getComputedStyle(details);
      const endHeight = open ? details.getBoundingClientRect().height :
        summary.getBoundingClientRect().height + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const state = { open };
      state.height = details.animate([
        { height: `${startHeight}px` }, { height: `${endHeight}px` }
      ], { duration: 240, easing: 'cubic-bezier(.2, 0, .2, 1)' });
      state.answer = answer.animate([
        { opacity: startOpacity, transform: startTransform },
        { opacity: open ? 1 : 0, transform: open ? 'none' : 'translateY(4px)' }
      ], { duration: 240, easing: 'ease-out', fill: 'both' });
      this.active.set(details, state);
      this.updateExpandState();
      state.height.onfinish = () => this.finish(details, state);
    }
  });
}
